import { Section } from 'tio-reimagined/components/layout';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import ProfileRecommendationsTable from './recommendations/table.gts';
import type IntlService from 'ember-intl/services/intl';
import type UserModel from 'tio-data/models/user';

export interface ProfileRecommendationsSignature {
  Args: {
    limit?: number;
    user: UserModel;
    recommendationType: string;
  };
  Element: HTMLElement;
}

export default class ProfileRecommendationsComponent extends Component<ProfileRecommendationsSignature> {
  @service declare intl: IntlService;

  get sectionHeader() {
    if (this.args.recommendationType === 'STRATEGY_FINDER') {
      return this.intl.t('common.strategy_finder.default');
    }
    return this.args.recommendationType;
  }

  <template>
    <Section @collapsed={{true}}>
      <:header>
        {{this.sectionHeader}}
        {{t "common.recommendations.default"}}
      </:header>
      <:body>
        {{#if @user.id}}
          <ProfileRecommendationsTable
            @user={{@user}}
            @recommendationType={{@recommendationType}}
            @limit={{@limit}}
          />
        {{/if}}
      </:body>
    </Section>
  </template>
}
